// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"ed2d0c049d2aadc6cd1b","6980":"be9ea299174a677ffff5"}[chunkId] + ".js";
};